import { TenantCard } from './TenantCard'
import { Skeleton } from '@/components/ui/Skeleton'
import type { TTenant, THealthCheck } from '@/types'

interface TenantGridProps {
  tenants: TTenant[]
  healthMap: Map<string, THealthCheck>
  onTenantClick: (tenant: TTenant) => void
  isLoading?: boolean
}

export function TenantGrid({ tenants, healthMap, onTenantClick, isLoading }: TenantGridProps) {
  if (isLoading) {
    return <LoadingSkeleton />
  }

  return (
    <div style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))',
      gap: '16px',
    }}>
      {tenants.map((tenant, index) => (
        <TenantCard
          key={tenant.id}
          tenant={tenant}
          healthCheck={healthMap.get(tenant.id)}
          onDetailsClick={() => onTenantClick(tenant)}
          animationDelay={index * 30}
        />
      ))}
    </div>
  )
}

function LoadingSkeleton() {
  return (
    <div style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))',
      gap: '16px',
    }}>
      {Array.from({ length: 6 }).map((_, i) => (
        <div
          key={i}
          style={{
            backgroundColor: 'var(--bg-secondary)',
            border: '1px solid var(--border-subtle)',
            borderRadius: 'var(--radius-lg)',
            padding: '20px',
            display: 'flex',
            flexDirection: 'column',
            gap: '14px',
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Skeleton width="55%" height={18} />
            <Skeleton width={60} height={22} borderRadius="var(--radius-full)" />
          </div>
          <Skeleton width="70%" height={14} />
          <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
            <Skeleton width="40%" height={14} />
            <Skeleton width="50%" height={11} />
          </div>
          <div style={{ display: 'flex', gap: '8px', marginTop: '4px' }}>
            <Skeleton width={70} height={30} borderRadius="var(--radius-md)" />
            <Skeleton width={34} height={30} borderRadius="var(--radius-md)" />
          </div>
        </div>
      ))}
    </div>
  )
}
